import { createAsyncThunk } from '@reduxjs/toolkit';
import { Punch } from './punchTypes';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Punch
export const createPunch = createAsyncThunk(
    'punches/create',
    async (punchData: any, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('EmployeeId', punchData.EmployeeId.toString());
            formData.append('PunchDate', punchData.PunchDate);
            formData.append('PunchTime', punchData.PunchTime);
            formData.append('PunchType', punchData.PunchType);
            formData.append('EmployeeCode', punchData.EmployeeCode);
            if (punchData.PunchOut !== undefined && punchData.PunchOut !== null) {
                formData.append('PunchOut', punchData.PunchOut);
            }

             
            if (punchData.Longitude !== undefined) {
                formData.append('Longitude', punchData.Longitude.toString());
            }
            if (punchData.Latitude !== undefined) {
                formData.append('Latitude', punchData.Latitude.toString());
            }
            formData.append('CreatedBy', punchData.CreatedBy.toString());
            formData.append('CheckInImage', punchData.file);
            const response = await employeeServiceApiInstance.post('/punch', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',  
                },
            });

            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create punch');
        }
    }
);


// Get Punch by ID
export const getPunchById = createAsyncThunk(
    'punches/fetchById',
    async (punchId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/punch/${punchId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch punch');
        }
    }
);

// Get Punches by Employee ID
export const getPunchByEmployeeId = createAsyncThunk(
    'punches/fetchByEmployeeId',
    async (employeeCode: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/punch/employee/${employeeCode}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch punches');
        }
    }
);
export const getPunchByEmployeeWithId = createAsyncThunk(
    'punchess/fetchByEmployeeWithId',
    async (employeeId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/punch/employee/Id/all/${employeeId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch punches');
        }
    }
);

// Update Punch
export const updatePunch = createAsyncThunk(
    'punches/update',
    async (
        { punchId, data }: { punchId: number; data: Partial<Punch> },
        { rejectWithValue }
    ) => {
        try {
            const formData = new FormData();
            for (const [key, value] of Object.entries(data)) {
                formData.append(key, value);
            }
            const response = await employeeServiceApiInstance.put(`/punch/${punchId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update punch');
        }
    }
);


// Delete Punch
export const deletePunch = createAsyncThunk(
    'punches/delete',
    async (punchId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/punch/${punchId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete punch');
        }
    }
);

export const getEmployeePresenceCount = createAsyncThunk(
    'punches/fetchPresenceCount',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/punch/employee/presence');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch employee presence count');
        }
    }
);

// Get Punches by Date
export const getPunchByDate = createAsyncThunk(
    'punches/fetchByDate',
    async (punchDate: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/punch/date/${punchDate}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch punches by date');
        }
    }
);

export const getEmployeeAttendanceByDate = createAsyncThunk(
    'punches/fetchAttendanceByDate',
    async (punchDate: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/punch/attendance/${punchDate}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch employee attendance');
        }
    }
);

export const createBulkPunchIn = createAsyncThunk(
    'leaveTypes/create',
    async (Data: Omit<any, 'Id'>, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/punch/bulkcreate', Data);
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create PunchIn');
        }
    }
);
export const getEmployeeAttendancehierarchy = createAsyncThunk(
    'leaveTypes/get',
    async (punchDate: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/punch/employee/attendance/hierarchy/${punchDate}`);
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create PunchIn');
        }
    }
);
export const BuildAttendance = createAsyncThunk(
    'leaveTypes/get',
    async ({month , year} :any , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/punch/attendance/summary/build?month=${month}&year=${year}`);
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to build attendnace');
        }
    }
);
export const getEmployeeShift = createAsyncThunk(
    'leaveTypes/getemployeeshift',
    async ({date , employee} :any , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/punch/attendance/employeeshift/idDate?date=${date}&employee_id=${employee}`);
            return response.data;  
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to build attendnace');
        }
    }
);





